import axios from 'axios';

const baseUrl = process.env.GATSBY_MENTORIA_FINANCIERA_BASE_URL;
const apikey = process.env.GATSBY_MENTORIA_FINANCIERA_API_KEY;
const endpoind = process.env.GATSBY_MENTORIA_FINANCIERA_API;
const tokenizar = process.env.GATSBY_MENTORIA_FINANCIERA_TOKENIZER;
const apiSFIN = process.env.GATSBY_MENTORIA_FINANCIERA_TRANSVERSAL_APIKEY;

export const mentoriaToken = async (uid: string) => {
	const data = JSON.stringify({
		"action": "getJWT"
	});
	try {
		const response = await axios.post(`${tokenizar}`, data, {
			headers: {
				"Content-Type": "application/json",
				"apikey": apikey
			},
		});
		return response?.data.data.id_token;
	} catch (error) {
		console.error(error);
	}
};


export const servicioRegistro = async (data: any, tk:string) => {
  try {
    const response = await axios.post(`${baseUrl}${endpoind}`, data, {
      headers: {
        'Content-Type': 'application/json',
        'apikey': apiSFIN,
        'Authorization': `Bearer ${tk}`
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};
